import {Link} from "@Common/react/cst2";

import {cs}        from "./chain-services";
import {fragments} from "./fragments";
import {UseState}  from "./use-state";

export const CountdownTimer = ({countdownTo, timeZone=undefined, refreshFrequency=1000, next}:{
    countdownTo       : Date,
    timeZone         ?: string,
    refreshFrequency ?: number,
    next              : Link<JSX.Element, Record<"days" | "difference" | "hours" | "minutes" | "seconds", number>>,
}) => cs(
    ["timeLeft", (_, next) => UseState({
        getInitValue: () => calculateTimeLeft({date: countdownTo, timeZone}),
        next,
    })],
    ({timeLeft}) => fragments(
        timeLeft?.value?.difference && setTimeout(()=>timeLeft.onChange(calculateTimeLeft({date: countdownTo, timeZone})), refreshFrequency) && '',
        next(timeLeft.value)
    )
);

const calculateTimeLeft = ({date, timeZone}) => {
    const difference = +date - +new Date(new Date().toLocaleString('en-US', { timeZone }));
    let timeLeft = {};
    if (difference > 0) {
        timeLeft = {
            days: Math.floor(difference / 1000 / 60 / 60 / 24),
            hours: Math.floor((difference / 1000 / 60 / 60) % 24),
            minutes: Math.floor((difference / 1000 / 60) % 60),
            seconds: Math.floor((difference / 1000) % 60),
            difference
        };
    }
    return timeLeft;
}
